export default __webpack_public_path__ + "static/media/reddit-logo-white.d364fcb5.png";